import queryString from "query-string";
import { GetTextSearch } from "../../../../assets/convertUrlFilter";
import {
  FILE_TYPE,
  MONTH,
  TEXT_SEARCH,
  YEAR
} from "../../../../constants/filters";
import { FILE_TYPES } from "../../../../constants/file";

export default (dateFilter = {}) => {
  let filters = queryString.parse(document.location.search);
  return filtersNormalize(filters, dateFilter);
};

const filtersNormalize = (filters, dateFilter) => {
  return {
    [FILE_TYPE]: FILE_TYPES.WEB,
    [TEXT_SEARCH]: GetTextSearch(filters[TEXT_SEARCH]),
    [YEAR]: filters[YEAR] ? filters[YEAR] : "",
    [MONTH]: filters[MONTH] ? filters[MONTH] : ""
  };
};
